import React from "react";

import { GridSinglePage } from "2g-grid";

import useZadostiHistorieGrid from "./useZadostiHistorieGrid";

export function ZadostiHistorieGrid() {
  const grid = useZadostiHistorieGrid();
  return <GridSinglePage {...grid} />;
}

ZadostiHistorieGrid.propTypes = {};

export default React.memo(ZadostiHistorieGrid);
